import { render, staticRenderFns } from "./GreetingQuestion.vue?vue&type=template&id=1b916bac&scoped=true&"
import script from "./GreetingQuestion.vue?vue&type=script&lang=js&"
export * from "./GreetingQuestion.vue?vue&type=script&lang=js&"
import style0 from "./GreetingQuestion.vue?vue&type=style&index=0&id=1b916bac&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b916bac",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VRow})
